/**
 * /igaming/multi-level — iGaming multi-level sub-affiliate manager (#156).
 *
 * Declares a TanStack Router route and renders `IgamingMultiLevelPage`. The
 * component is imported by the root-owned `router.tsx` via module
 * augmentation — agents never touch `router.tsx` themselves; the root
 * wire-up cycle picks this route up after the prod merge.
 */
import { Link, createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IgamingMultiLevelPage } from "@/features/igaming-multi-level/IgamingMultiLevelPage";

// ---------------------------------------------------------------------------
// Route definition.
// ---------------------------------------------------------------------------

export const igamingMultiLevelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming/multi-level",
	component: IgamingMultiLevelRoute,
});

export default igamingMultiLevelRoute;

// ---------------------------------------------------------------------------
// Page shell — breadcrumb + live feature component.
// ---------------------------------------------------------------------------

export function IgamingMultiLevelRoute() {
	return (
		<div className="mx-auto flex w-full max-w-5xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<IgamingMultiLevelPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">iGaming</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Multi-level</li>
			</ol>
		</nav>
	);
}
